import { RouteComponentProps } from 'react-router-dom';
import { isNil, noop, some } from 'es-toolkit/compat';
import clsx from 'clsx';

import { Alert, Typography } from 'omakase';
import { StoreType } from '@tock/shared/utils/connect';
import { safeEnumCompare } from '@tock/coretypes';
import BaseComponent from '@tock/shared/components/BaseComponent';
import SectionHeader from 'components/SectionHeader';
import protos from 'utils/protos';
import uiFlowComponent, { FlowProps } from 'components/ui-flow/uiFlowComponent';

const { TicketType } = protos;

export interface Props extends RouteComponentProps {
  onSetTransferPrice(price: number): void;
  onSetIsGiftFlow(isGiftFlow: boolean): void;
  transfer: StoreType['transfer'];
}

class TransferRoute extends BaseComponent<Props & FlowProps> {
  handleGiftTransfer() {
    this.props.onSetTransferPrice(0);
    this.props.onSetIsGiftFlow(true);
    this.props.history.push(this.props.nextRoute);
  }

  handleTransfer() {
    this.props.onSetIsGiftFlow(false);
    this.props.history.push(this.props.nextRoute);
  }

  render() {
    const { transfer } = this.props;
    const isGiftCardPurchase = some(transfer.purchase.discount, (discount) => {
      return !isNil(discount.giftCard);
    });

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const restaurantName = transfer.purchase.business!.name;
    const type = safeEnumCompare(
      transfer.purchase.ticketTypeVariety,
      TicketType.Variety,
      TicketType.Variety.DEPOSIT
    )
      ? 'deposit'
      : 'ticket';
    const giftCardWarning = `You used a gift card to purchase this ${type}.  To sell your reservation please contact ${restaurantName}`;
    const divClassname = clsx('Transfer-item', { 'is-disabled': isGiftCardPurchase });
    const handler = !isGiftCardPurchase ? this.handleTransfer : noop;

    return (
      <div className="MainContent is-transfers">
        <div className="SectionWrapper">
          <div className="SectionContent">
            <SectionHeader
              heading="Select Transfer Type"
              subheading="You can sell or give away your reservation."
            />

            {isGiftCardPurchase && (
              <div className="Transfer-giftCardAlert">
                <Alert withoutIcon>{giftCardWarning}</Alert>
              </div>
            )}

            <button className={divClassname} onClick={handler}>
              <h3 className="Transfer-itemTitle">
                <Typography color="inherit" component="span" variant="heading03">
                  Sell your reservation
                </Typography>
              </h3>

              <p className="Transfer-paragraph">
                <Typography color="inherit" component="span" variant="body02">
                  You can sell your reservation for up to the amount paid and we'll return the funds
                  to your credit card. Select a recipient and the amount to charge them to start the
                  transfer process.
                </Typography>
              </p>
            </button>

            <div className="Transfer--divider">
              <Typography color="inherit" component="span" variant="body02Strong">
                OR
              </Typography>
            </div>

            <button className="Transfer-item" onClick={this.handleGiftTransfer}>
              <h3 className="Transfer-itemTitle">
                <Typography color="inherit" component="span" variant="heading03">
                  Give your reservation
                </Typography>
              </h3>

              <p className="Transfer-paragraph">
                <Typography color="inherit" component="span" variant="body02">
                  You can give your reservation to someone with no charge to them. Select a
                  recipient to start the transfer process.
                </Typography>
              </p>
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default uiFlowComponent(TransferRoute);
